import { render, staticRenderFns } from "./log-activity-detail.vue?vue&type=template&id=24b6fc30&scoped=true&"
import script from "./log-activity-detail.vue?vue&type=script&lang=js&"
export * from "./log-activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./log-activity-detail.vue?vue&type=style&index=0&id=24b6fc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6fc30",
  null
  
)

export default component.exports